import { render, staticRenderFns } from "./GuidedTourSplash.vue?vue&type=template&id=d3822f40&scoped=true&"
import script from "./GuidedTourSplash.vue?vue&type=script&lang=js&"
export * from "./GuidedTourSplash.vue?vue&type=script&lang=js&"
import style0 from "./GuidedTourSplash.vue?vue&type=style&index=0&id=d3822f40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3822f40",
  null
  
)

export default component.exports